module.exports = __webpack_public_path__ + "static/img/powered-by-light-transparent.988d9a66.svg";